import { createBasicLocation } from "src/router/routeTypes"

const MinutAI = createBasicLocation("/minut-ai")

const MinutAIContentLibrary = createBasicLocation(
  `${MinutAI.location().pathname}/knowledge`
)

export const MinutAIRoutes = {
  MinutAIContentLibrary,
} as const
